export const START_EDITOR_POSITION = [0, 0];
